module.exports = __webpack_public_path__ + "img/bioshock (5).21b92bfa.jpg";